import * as internal from "stream";

export class UserRolesModel {
    id: number;
    name: string;
    normalizedname: string;
    selected: boolean;

    constructor(id: number, name: string, normalizedname: string, selected: boolean) {
        this.id = id;
        this.name = name;
        this.normalizedname = normalizedname;
        this.selected = selected;
    }
}